import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface ICabecalhoInclusaoContasAPagar {
  id: number;
  numPrevisao: number;
  valorTotal: number;
  fornecedor: string;
  emissao: string | null;
  vencimento: string | null;
  observacao: string;
  valorPago: number;
  valorRestante: number;
}

export interface INotaInclusaoContasAPagar {
  documento: string;
  parcela: number;
  valorLancado: number;
  pago: boolean;
}

export interface IDetalhesInclusaoContasAPagar {
  cabecalho: ICabecalhoInclusaoContasAPagar;
  notas: INotaInclusaoContasAPagar[];
}

export const ObterDetalhesDaInclusaoDeContasAPagar = async (
  documento: string,
  codLoja: number
): Promise<IDetalhesInclusaoContasAPagar> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IDetalhesInclusaoContasAPagar>(
      `/obter-detalhes-da-previsao-de-pagamento`,
      { params: { documento, codLoja }, headers: { token } }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível obter os detalhes da inclusão de contas a pagar"
    );
  }
};